import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';
@Directive({
    selector: '[appHighlight]',
    standalone: true
})
export class HighlightDirective{
  constructor(private elRef: ElementRef, private renderer: Renderer2) { }
  @HostListener('mouseenter') mouseover(eventData: Event){
    this.renderer.setStyle(this.elRef.nativeElement, 'color', 'black');
  }
  @HostListener('mouseleave') mouseexit(eventData: Event){
    this.renderer.setStyle(this.elRef.nativeElement, 'color', '#1E90FF');
  }
}